import React from 'react';
import { useDragLayer } from 'react-dnd';

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px) rotate(-2deg)`;
  return {
    transform: transform,
    WebkitTransform: transform,
  };
}

const dragLayerStyle: React.CSSProperties = {
  backgroundColor: 'transparent',
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 10000,
  left: 0,
  top: 0,
};

const dragLayerItemStyle: React.CSSProperties = {
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
};

interface DragLayerProps {
  types: string[];
  children: (p: any) => React.ReactNode;
}

/**
 * Draws a translucent version of `children` for dragging. Used to
 * gain more control over how dragged items are styled.
 */
const DragLayer: React.FC<DragLayerProps> = ({ children, types }) => {
  const dragLayerProps = useDragLayer(monitor => ({
    currentOffset: monitor.getSourceClientOffset(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
  }));

  if (!dragLayerProps.isDragging) {
    return null;
  }

  if (!dragLayerProps.item || !types.includes(dragLayerProps.item.type)) {
    return null;
  }

  return (
    <div
      ref={el => {
        el?.showPopover();
      }}
      style={dragLayerStyle}
      popover='manual'
    >
      <div
        style={{ ...dragLayerItemStyle, ...getItemStyles(dragLayerProps) }}
        className={types.map(type => `drag-layer__item--${type}`).join(' ')}
      >
        {children(dragLayerProps)}
      </div>
    </div>
  );
};

export default DragLayer;
